var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.list.length ? _c('Module', {
    directives: [{
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    staticClass: "container",
    attrs: {
      "backgroundImage": _vm.data.tModDescInfo.sBgPic || ''
    }
  }, [_vm.list.length ? _c('Title', {
    attrs: {
      "title": _vm.data.tModDescInfo.sTitle,
      "data": _vm.data,
      "hideTitle": true,
      "isInSecondKill": true,
      "report": _vm.reportData.更多
    }
  }) : _vm._e(), _c('p', {
    staticClass: "container-title"
  }), _c('HorizontalScroll', _vm._l(_vm.killList, function (item, index) {
    return item ? _c('SecondKillItem', {
      key: index,
      attrs: {
        "index": index,
        "item": item,
        "isOnlyOne": _vm.list.length === 1
      },
      on: {
        "order": _vm.afterOrder
      }
    }) : _vm._e();
  }), 1), _vm.showAskFollowModalActId ? _c('AskFollow', {
    key: _vm.showAskFollowModalActId,
    on: {
      "close": function close($event) {
        _vm.showAskFollowModalActId = 0;
      }
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };